// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-heading {
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.300001px;
}

.module-heading {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.300001px;
}

.sub-heading {
  font-weight: 500;
  font-size: 2vh;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  opacity: 0.53;
  margin-left: 25px;
}

.actions {
  margin-right: 15px;
}

.heading-container {
  border-left: 5px solid var(--theme-header-border-color, #8DE7E3);
  background-color: var(--theme-main-background-color, #055C8D);
  color: white;
  padding-left: 15px;
  height: 57px;
  margin-bottom: 15px;
}

.button-left-margin {
  margin-left: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
